/* eslint-disable @typescript-eslint/no-var-requires */
import {
    isFeatureEnabled,
    toFeatureState,
} from '@etrigan/feature-toggles-client'
import { metrics, TheWestSection } from '@news-mono/component-library'
import { StaticRoutes, Topic } from '@news-mono/web-common'
import { layout } from '../../../App.routing'
import { billboardLeaderboardMrec } from '../../ad-units'

const topic: Topic = {
    id: 'sport/olympics',
    title: 'Olympics',
    parent: { id: 'sport', title: 'Sport', metadata: {}, seoTitle: '' },
    metadata: {},
    seoTitle: '',
}

export const getOlympicResultsRouteInfo: StaticRoutes<TheWestSection> = {
    '/sport/olympics/results': ({ getAdTargeting, config, store }) => {
        const enableRoute = isFeatureEnabled(
            toFeatureState(store.getState().toggles),
            'the-west-tokyo',
        )

        if (!enableRoute) {
            return null
        }

        const canonicalUrl = config.publicUrl + '/sport/olympics/results'

        return {
            kind: 'page',
            heading: 'Results',
            pageType: 'home',
            hideHeading: true,
            refreshOnInactive: false,
            pageMeta: {
                title: 'Results',
                description: 'Shows the event results for the Tokyo Olympics',
                link: [{ rel: 'canonical', href: canonicalUrl }],
            },
            socialMeta: {
                title: 'Results',
                description: 'Shows the event results for the Tokyo Olympics',
            },
            adTargeting: getAdTargeting('home', 'default', topic),
            section: 'default',
            compositions: [
                layout.composition({
                    type: 'box',
                    props: {
                        containerWidth:
                            metrics.thewest.siteMetrics.mainContentWidth,
                        horizontalGutters: 'outerMargin',
                        verticalGutters: ['outerMargin', 'unset'],
                    },
                    contentAreas: {
                        main: [
                            layout.component({
                                type: 'breaking-news',
                                props: {
                                    dataDefinitionArgs: {
                                        type: 'curation',
                                        name: 'breaking-news',
                                        offset: 0,
                                        pageSize: 1,
                                    },
                                },
                            }),
                            layout.component({
                                type: 'breadcrumb',
                                props: {
                                    items: [
                                        { text: 'sport', href: '/sport' },
                                        {
                                            text: 'olympics',
                                            href: '/sport/olympics',
                                        },
                                    ],
                                },
                            }),
                        ],
                    },
                }),
                layout.composition({
                    type: 'thor',
                    props: {
                        containerWidth:
                            metrics.thewest.siteMetrics.mainContentWidth,
                        horizontalGutters: true,
                    },
                    contentAreas: {
                        main: [
                            layout.nestedComposition({
                                type: 'janus',
                                props: {
                                    layoutRatio: '3:1',
                                    stretchColumns: true,
                                    verticalSpacing: 'xl',
                                    hasSidebar: true,
                                    themeOverride: 'tokyo',
                                },
                                contentAreas: {
                                    left: [
                                        layout.component({
                                            type: 'stats-results',
                                            props: { isFullSize: true },
                                        }),
                                    ],
                                    right: [
                                        layout.component({
                                            type: 'sidebar-header',
                                            props: {},
                                        }),
                                        layout.component({
                                            type: 'lima',
                                            props: {
                                                section: 'news',
                                                initialColumns: 1,
                                                intermediateColumns: 1,
                                                finalColumns: 1,
                                                verticalSpacing: 'xl',
                                                hasBackground: true,
                                                hasBorder: false,
                                                themeOverride: 'tokyo',
                                                cardOrientation: {
                                                    type: 'Landscape-Portrait',
                                                },
                                                cardLayout: [
                                                    ['common'],
                                                    ['common'],

                                                    {
                                                        type: 'november',
                                                        listLength: 3,
                                                    },
                                                ],
                                                dataDefinitionArgs: {
                                                    type: 'curation',
                                                    name: 'olympics',
                                                    offset: 0,
                                                    pageSize: 5,
                                                },
                                            },
                                        }),
                                    ],
                                },
                            }),
                            ...billboardLeaderboardMrec('two'),
                        ],
                    },
                }),
            ],
        }
    },
}
